import React, { Component, Fragment } from 'react'
import EditItemFieldContainer from './edit_item_field_container.jsx'
import { trashIcon } from '../../../../Templates/icons'
import { isImage,hasSpecialChar } from '../../../../Templates/functions'
import {createAttachmentInUse} from '../../../../../util/wi_util'
import { fileKey, fileUrl } from '../../../../../util/file_url'
import FormColumn from '../../../../Templates/FormColumn'
import moment from 'moment'
import PlusIcon from '../../../../../assets/Icons/plus-icon.png'
import { cloneDeep } from 'lodash'
// Light table color
// const invertColor = '#8AA9FF'
// Dark table color
const invertColor = '#52628F'
export default class PublicationPage extends Component {
    constructor(props) {
        super()
        let page = props.publicationPage ? props.publicationPage : {}
        this.state = {
            previewImage: null,
            imageOptions: null,
            uploadedImage: false,
            uniqueImageName: true,
            editedWITitle: props.title,
            lastClickedImage: null,
            selectedImage: null,
            showingPreviewOptions: false,
            docNum: page.docNum || "",
            identificationAndClassification: page.identificationAndClassification || "",
            system: page.system || "",
            subSystem: page.subSystem || "",
            subject: page.subject || "",
            references: page.references || [],
            figures: page.figures || [],
            enclosures: page.enclosures || [],
            rescissionDate: page.rescissionDate || null,
            reference: "",
            figure: "",
            enclosure: "",
            editingItem: "",
            isImageSaved: true,
            imageName: "",
            generateDateOptionsArray: []
        }
        this.handleFileChange = this.handleFileChange.bind(this);
    }

    componentDidMount = async () => {
        console.log(`[Publication Modal] componentDidMount called, activeElement:`, document.activeElement);
        
        // Set initial state BEFORE setting up focus protection to avoid DOM conflicts
        console.log(`[Publication Modal] Setting initial state early to prevent focus conflicts`);
        this.setState({
            editedWITitle: this.props.title,
        });
        
        this.setupGlobalFocusProtection();
        
        // Generate async options after focus protection is set up
        let imageOptions = await this.generatePreviewImageOptions()
        let OptionsArray = [this.generateDateOptions(1),this.generateDateOptions(3),this.generateDateOptions(5)]
        
        console.log(`[Publication Modal] Setting remaining async state`);
        this.setState({
            imageOptions,
            generateDateOptionsArray: OptionsArray
        }, () => {
            try {
                const selectedTabPanel = document.querySelector('.react-tabs__tab-panel--selected');
                const isNestedWI = selectedTabPanel && selectedTabPanel.id !== 'react-tabs-1';
                if (isNestedWI) {
                    // After async setState completes in nested WI, re-focus WI title input if present
                    requestAnimationFrame(() => {
                        const input = document.getElementById('wi-title-input');
                        if (input && document.activeElement !== input) {
                            console.log('[Publication Modal] Refocusing WI Title after async state in nested WI');
                            input.focus();
                        }
                    });
                }
            } catch (e) {
                console.log('[Publication Modal] Post-state nested WI refocus check failed:', e);
            }
        })
        console.log(`[Publication Modal] All state setup completed, activeElement:`, document.activeElement);
    }

    componentDidUpdate = (prevProps, prevState) => {
        console.log("PublicationPage component updated, activeElement:", document.activeElement);
        
        // Log prop changes
        const propChanges = Object.keys(prevProps).filter(key => {
            return prevProps[key] !== this.props[key];
        });
        
        if (propChanges.length > 0) {
            console.log("Prop changes:", propChanges);
            propChanges.forEach(key => {
                console.log(`Prop '${key}' changed from:`, prevProps[key], "to:", this.props[key]);
            });
        }

        // Log state changes
        const stateChanges = Object.keys(prevState).filter(key => {
            return prevState[key] !== this.state[key];
        });
        
        if (stateChanges.length > 0) {
            console.log("State changes:", stateChanges);
            stateChanges.forEach(key => {
                console.log(`State '${key}' changed from:`, prevState[key], "to:", this.state[key]);
            });
        }
    }

    componentWillUnmount = () => {
        this.setPublicationPage()
        this.cleanupGlobalFocusProtection();
    }

    setupGlobalFocusProtection = () => {
        // Generate unique ID for this publication modal instance
        const editorInstanceId = `publication_${Date.now()}_${Math.random()}`;
        this.editorInstanceId = editorInstanceId;

        // Use the same global event delegation pattern as the Editor and Step Title
        if (!window._publicationModalRegistry) {
            window._publicationModalRegistry = new Map();
            // Set up global click listener only once
            const globalClickHandler = (event) => {
                console.log('[Global Publication] Click detected, checking modals...');
                
                // Find which tab panels are in the event path
                const eventPath = event.composedPath ? event.composedPath() : [];
                const tabPanelsInPath = eventPath.filter(element => 
                    element.classList && element.classList.contains('tabPageElement')
                );
                
                console.log('[Global Publication] Tab panels in click path:', tabPanelsInPath.map(tp => tp.id));
                
                // Only call handlers for modals that are NOT in the clicked tab panel
                window._publicationModalRegistry.forEach((modalInfo, modalId) => {
                    if (modalInfo.handler && modalInfo.isActive) {
                        const isClickInModalTab = tabPanelsInPath.some(tabPanel => 
                            tabPanel === modalInfo.tabPanel
                        );
                        
                        if (!isClickInModalTab) {
                            console.log(`[Global Publication] Click outside modal ${modalId}, calling handler`);
                            modalInfo.handler(event);
                        } else {
                            console.log(`[Global Publication] Click within modal ${modalId} tab, ignoring`);
                        }
                    }
                });
            };
            
            const container = document.getElementById("LeftRightAuthorContainer");
            if (container) {
                container.addEventListener("click", globalClickHandler, true);
                console.log('[Global Publication] Global click listener established');
            }
        }
        
        // Find this modal's tab panel
        let myTabPanel = null;
        try {
            // The modal is rendered inside a React Portal, so we need to find the tab panel differently
            // Look for the currently selected/active tab panel since the modal belongs to the active tab
            const selectedTabPanel = document.querySelector('.react-tabs__tab-panel--selected');
            if (selectedTabPanel && selectedTabPanel.classList.contains('tabPageElement')) {
                myTabPanel = selectedTabPanel;
                console.log(`[Publication Modal] Found active tab panel:`, selectedTabPanel.id);
        } else {
                console.log(`[Publication Modal] No active tab panel found`);
            }
        } catch (error) {
            console.log(`[Publication Modal] Error finding tab panel:`, error);
        }
        
        // Register this modal
        window._publicationModalRegistry.set(editorInstanceId, {
            handler: this.handleModalClickOutside,
            isActive: true,
            tabPanel: myTabPanel
        });
        
        console.log(`[Publication Modal ${editorInstanceId}] Registered in global registry`);
        console.log(`[Publication Modal ${editorInstanceId}] My tab panel:`, myTabPanel?.id);
        console.log(`[Global Publication] Total active modals:`, window._publicationModalRegistry.size);

        // Make the tabs subtree inert while modal is open to prevent focus steals
        try {
            const tabsRoot = document.querySelector('#wi-author-container .react-tabs');
            if (tabsRoot) {
                tabsRoot.setAttribute('inert', '');
                tabsRoot.setAttribute('aria-hidden', 'true');
                this._tabsRootEl = tabsRoot;
            }
        } catch (e) {}

        // Block tab header focus and set up input protection
        try {
            if (!this.modalFocusBlocker) {
                this.modalFocusBlocker = (e) => {
                    const t = e.target;
                    if (t && t.classList && t.classList.contains('react-tabs__tab')) {
                        e.stopPropagation();
                        e.preventDefault();
                        // Keep focus within modal
                        try {
                            const focused = document.querySelector('#publication-page input:focus')
                                           || document.getElementById('wi-title-input')
                                           || document.querySelector('#publication-page input');
                            if (focused && !focused.disabled) focused.focus();
                        } catch (err) {}
                    }
                };
                document.addEventListener('focusin', this.modalFocusBlocker, true);
            }
            if (!document.getElementById('wi-modal-tabs-block')) {
                const style = document.createElement('style');
                style.id = 'wi-modal-tabs-block';
                style.textContent = `.react-tabs__tab { pointer-events: none !important; }`;
                document.head.appendChild(style);
            }
        } catch (e) {}

        this.setupInputFocusProtection();
    }

    setupInputFocusProtection = () => {
        // Disable tab headers to prevent focus stealing
        const tabHeaders = document.querySelectorAll('.react-tabs__tab');
        tabHeaders.forEach(tab => {
            if (tab.getAttribute('tabindex') !== '-1') {
                tab.setAttribute('data-original-tabindex-pub', tab.getAttribute('tabindex') || '0');
                tab.setAttribute('tabindex', '-1');
                console.log(`[Publication Modal ${this.editorInstanceId}] Disabled tabindex for tab:`, tab.id);
            }
        });

        // Add event listeners to all publication inputs
        const inputIds = [
            "identification/classification",
            "docNum", 
            "system",
            "subSystem",
            "subject",
            "reference",
            "figure", 
            "enclosure"
        ];

        inputIds.forEach(inputId => {
            const input = document.getElementById(inputId);
            if (input) {
                // Add focus protection events
                input.addEventListener('focus', this.handleInputFocus);
                input.addEventListener('blur', this.handleInputBlur);
                input.addEventListener('click', this.handleInputClick);
                input.addEventListener('keydown', this.handleInputKeydown);
                
                console.log(`[Publication Modal ${this.editorInstanceId}] Added focus protection to input:`, inputId);
            }
        });

        // Find this modal's tab panel (already found earlier, use that reference)
        const activeTabPanel = document.querySelector('.react-tabs__tab-panel--selected');
        const currentTabPanel = activeTabPanel && activeTabPanel.classList.contains('tabPageElement') ? activeTabPanel : null;

        // Check if this is a nested WI (tab index > 0)
        const isNestedWI = currentTabPanel && currentTabPanel.id !== 'react-tabs-1';
        console.log(`[Publication Modal ${this.editorInstanceId}] Is nested WI:`, isNestedWI, 'Tab panel:', currentTabPanel?.id);
        
        if (isNestedWI) {
            console.log(`[Publication Modal ${this.editorInstanceId}] Nested WI detected - disabling WI Title protection to let FormColumn handle it`);
            // For nested WIs, let FormColumn handle WI Title focus completely
            // Don't add any protection that might interfere
        } else {
            // Also protect the Work Instruction Title input (which doesn't have an ID)
            // It's generated by FormColumn component and has specific styling
            const wiTitleInput = document.querySelector('input[style*="border: none"][style*="background: transparent"]');
            if (wiTitleInput) {
                console.log(`[Publication Modal ${this.editorInstanceId}] Found WI Title input:`, wiTitleInput);
                console.log(`[Publication Modal ${this.editorInstanceId}] WI Title current value:`, wiTitleInput.value);
                console.log(`[Publication Modal ${this.editorInstanceId}] WI Title current activeElement:`, document.activeElement);
                console.log(`[Publication Modal ${this.editorInstanceId}] WI Title input already focused:`, document.activeElement === wiTitleInput);
                
                // Add focus protection events to WI Title input
                wiTitleInput.addEventListener('focus', this.handleWITitleFocus);
                wiTitleInput.addEventListener('blur', this.handleWITitleBlur);
                wiTitleInput.addEventListener('click', this.handleWITitleClick);
                wiTitleInput.addEventListener('keydown', this.handleWITitleKeydown);
                
                // Give it an ID for easier reference
                wiTitleInput.id = 'wi-title-input';
                
                console.log(`[Publication Modal ${this.editorInstanceId}] Added focus protection to WI Title input`);
                
                // Since FormColumn won't auto-focus when protection is active, we need to focus manually
                console.log(`[Publication Modal ${this.editorInstanceId}] Manually focusing WI Title input since FormColumn deferred to us`);
                wiTitleInput.focus();
                console.log(`[Publication Modal ${this.editorInstanceId}] Manual focus completed, new activeElement:`, document.activeElement);
            } else {
                console.log(`[Publication Modal ${this.editorInstanceId}] WI Title input not found - checking all inputs:`, 
                    Array.from(document.querySelectorAll('input')).map(input => ({
                        id: input.id,
                        style: input.getAttribute('style'),
                        value: input.value
                    }))
                );
            }
        }
    }

    handleModalClickOutside = (event) => {
        // This is called by the global click handler when a click is outside this modal's tab
        // For now, we don't want to close the modal on outside clicks, just prevent focus issues
        console.log(`[Publication Modal ${this.editorInstanceId}] Click outside modal tab detected`);
    }

    handleInputFocus = (e) => {
        console.log(`[Publication Modal ${this.editorInstanceId}] Input gained focus:`, e.target.id);
    }

    handleInputBlur = (e) => {
        console.log(`[Publication Modal ${this.editorInstanceId}] Input lost focus:`, e.target.id, 'relatedTarget:', e.relatedTarget);
        
        // Check if focus is moving to a tab header inappropriately
        const isMovingToTabHeader = e.relatedTarget && e.relatedTarget.classList.contains('react-tabs__tab');
        
        // Also check for null relatedTarget which can happen when focus is lost unexpectedly
        const isUnexpectedBlur = e.relatedTarget === null;
        
        if (isMovingToTabHeader) {
            console.log(`[Publication Modal ${this.editorInstanceId}] Focus moving to tab header, refocusing input`);
            setTimeout(() => {
                if (e.target && !e.target.disabled) {
                    e.target.focus();
                }
            }, 10);
        } else if (isUnexpectedBlur) {
            console.log(`[Publication Modal ${this.editorInstanceId}] Unexpected blur on ${e.target.id} (null relatedTarget), checking if should refocus`);
            // Give a moment to see if focus goes somewhere legitimate, then refocus if needed
            setTimeout(() => {
                const currentActiveElement = document.activeElement;
                const isWithinModal = currentActiveElement && currentActiveElement.closest('[aria-labelledby="simple-modal-title"]');
                const isInputField = currentActiveElement && (currentActiveElement.tagName === 'INPUT' || currentActiveElement.tagName === 'TEXTAREA');
                
                // Only refocus if focus didn't go to another input within the modal
                if (!isWithinModal || !isInputField) {
                    console.log(`[Publication Modal ${this.editorInstanceId}] Focus not on valid modal input, refocusing ${e.target.id}`);
                    if (e.target && !e.target.disabled) {
                        e.target.focus();
                    }
                } else {
                    console.log(`[Publication Modal ${this.editorInstanceId}] Focus is on valid modal input:`, currentActiveElement.id || currentActiveElement.tagName);
                }
            }, 50);
        }
    }

    handleInputClick = (e) => {
        console.log(`[Publication Modal ${this.editorInstanceId}] Input clicked:`, e.target.id, 'preventing bubbling');
        e.stopPropagation();
    }

    handleInputKeydown = (e) => {
        console.log(`[Publication Modal ${this.editorInstanceId}] Key pressed in:`, e.target.id, 'key:', e.key);
        e.stopPropagation();
        
        // Still call the original checkKey function for specific input handling
        const fieldMap = {
            "identification/classification": "identificationAndClassification",
            "docNum": "docNum",
            "system": "system", 
            "subSystem": "subSystem",
            "subject": "subject",
            "reference": "reference",
            "figure": "figure",
            "enclosure": "enclosure"
        };
        
        const fieldName = fieldMap[e.target.id];
        if (fieldName) {
            this.checkKey(e, fieldName);
        }
    }

    // Specific handlers for WI Title input
    handleWITitleFocus = (e) => {
        console.log(`[Publication Modal ${this.editorInstanceId}] WI Title input gained focus at:`, Date.now());
        console.log(`[Publication Modal ${this.editorInstanceId}] Current activeElement:`, document.activeElement);
        console.log(`[Publication Modal ${this.editorInstanceId}] Focus event target:`, e.target);
        console.log(`[Publication Modal ${this.editorInstanceId}] Focus event timeStamp:`, e.timeStamp);
        
        // Add a stack trace to see what triggered the focus
        console.log(`[Publication Modal ${this.editorInstanceId}] Focus stack trace:`, new Error().stack);
    }

    handleWITitleBlur = (e) => {
        console.log(`[Publication Modal ${this.editorInstanceId}] WI Title input lost focus, relatedTarget:`, e.relatedTarget);
        console.log(`[Publication Modal ${this.editorInstanceId}] Current activeElement after blur:`, document.activeElement);
        console.log(`[Publication Modal ${this.editorInstanceId}] Blur event target:`, e.target);
        console.log(`[Publication Modal ${this.editorInstanceId}] Blur event timeStamp:`, e.timeStamp);
        console.log(`[Publication Modal ${this.editorInstanceId}] Blur at timestamp:`, Date.now());
        
        // Add a stack trace to see what triggered the blur
        console.log(`[Publication Modal ${this.editorInstanceId}] Blur stack trace:`, new Error().stack);
        
        // Check if focus is moving to a tab header inappropriately
        const isMovingToTabHeader = e.relatedTarget && e.relatedTarget.classList.contains('react-tabs__tab');
        
        // Also check for null relatedTarget which can happen when focus is lost unexpectedly
        // (due to React re-renders, DOM changes, etc.)
        const isUnexpectedBlur = e.relatedTarget === null;
        
        if (isMovingToTabHeader) {
            console.log(`[Publication Modal ${this.editorInstanceId}] WI Title focus moving to tab header, refocusing input`);
            setTimeout(() => {
                if (e.target && !e.target.disabled) {
                    e.target.focus();
                }
            }, 10);
        } else if (isUnexpectedBlur) {
            console.log(`[Publication Modal ${this.editorInstanceId}] WI Title unexpected blur (null relatedTarget), checking if should refocus`);
            console.log(`[Publication Modal ${this.editorInstanceId}] Blur timestamp:`, Date.now());
            // Give a moment to see if focus goes somewhere legitimate, then refocus if needed
            setTimeout(() => {
                const currentActiveElement = document.activeElement;
                const isWithinModal = currentActiveElement && currentActiveElement.closest('[aria-labelledby="simple-modal-title"]');
                const isInputField = currentActiveElement && (currentActiveElement.tagName === 'INPUT' || currentActiveElement.tagName === 'TEXTAREA');
                
                console.log(`[Publication Modal ${this.editorInstanceId}] After 50ms delay - activeElement:`, currentActiveElement);
                console.log(`[Publication Modal ${this.editorInstanceId}] isWithinModal:`, isWithinModal, 'isInputField:', isInputField);
                
                // Only refocus if focus didn't go to another input within the modal
                if (!isWithinModal || !isInputField) {
                    console.log(`[Publication Modal ${this.editorInstanceId}] Focus not on valid modal input, refocusing WI Title`);
                    console.log(`[Publication Modal ${this.editorInstanceId}] Original target:`, e.target);
                    
                    // The original e.target might be detached from DOM due to React re-render
                    // Find the current WI Title input in the DOM
                    const currentWITitleInput = document.getElementById('wi-title-input') || 
                                               document.querySelector('input[style*="border: none"][style*="background: transparent"]');
                    
                    console.log(`[Publication Modal ${this.editorInstanceId}] Current WI Title input found:`, !!currentWITitleInput);
                    console.log(`[Publication Modal ${this.editorInstanceId}] Current input element:`, currentWITitleInput);
                    
                    if (currentWITitleInput && !currentWITitleInput.disabled) {
                        console.log(`[Publication Modal ${this.editorInstanceId}] Focusing current WI Title input`);
                        currentWITitleInput.focus();
                        console.log(`[Publication Modal ${this.editorInstanceId}] Refocus completed, new activeElement:`, document.activeElement);
                        console.log(`[Publication Modal ${this.editorInstanceId}] Successfully focused:`, document.activeElement === currentWITitleInput);
                    } else {
                        console.log(`[Publication Modal ${this.editorInstanceId}] Could not find or focus WI Title input`);
                    }
                } else {
                    console.log(`[Publication Modal ${this.editorInstanceId}] Focus is on valid modal input:`, currentActiveElement.id || currentActiveElement.tagName);
                }
            }, 50);
        }
    }

    handleWITitleClick = (e) => {
        console.log(`[Publication Modal ${this.editorInstanceId}] WI Title input clicked, preventing bubbling`);
        console.log(`[Publication Modal ${this.editorInstanceId}] Click target:`, e.target);
        console.log(`[Publication Modal ${this.editorInstanceId}] Current activeElement:`, document.activeElement);
        console.log(`[Publication Modal ${this.editorInstanceId}] Click timestamp:`, Date.now());
        console.log(`[Publication Modal ${this.editorInstanceId}] Input value:`, e.target.value);
        console.log(`[Publication Modal ${this.editorInstanceId}] Active tab panel:`, document.querySelector('.react-tabs__tab-panel--selected')?.id);
        e.stopPropagation();
    }

    handleWITitleKeydown = (e) => {
        console.log(`[Publication Modal ${this.editorInstanceId}] Key pressed in WI Title:`, e.key);
        e.stopPropagation();
        // WI Title input handles its own onChange, so we don't need to call checkKey
    }

    cleanupGlobalFocusProtection = () => {
        // Restore tab indexes
        this.restoreTabIndexes();
        
        // Remove all input event listeners
        const inputIds = [
            "identification/classification",
            "docNum", 
            "system",
            "subSystem", 
            "subject",
            "reference",
            "figure",
            "enclosure"
        ];

        inputIds.forEach(inputId => {
            const input = document.getElementById(inputId);
            if (input) {
                input.removeEventListener('focus', this.handleInputFocus);
                input.removeEventListener('blur', this.handleInputBlur);
                input.removeEventListener('click', this.handleInputClick);
                input.removeEventListener('keydown', this.handleInputKeydown);
            }
        });

        // Also remove WI Title input listeners
        const wiTitleInput = document.getElementById('wi-title-input');
        if (wiTitleInput) {
            wiTitleInput.removeEventListener('focus', this.handleWITitleFocus);
            wiTitleInput.removeEventListener('blur', this.handleWITitleBlur);
            wiTitleInput.removeEventListener('click', this.handleWITitleClick);
            wiTitleInput.removeEventListener('keydown', this.handleWITitleKeydown);
            
            // Remove the ID we added
            wiTitleInput.removeAttribute('id');
            
            console.log(`[Publication Modal ${this.editorInstanceId}] Removed focus protection from WI Title input`);
        }
        
        // Unregister from global registry
        if (window._publicationModalRegistry && this.editorInstanceId) {
            window._publicationModalRegistry.delete(this.editorInstanceId);
            console.log(`[Publication Modal ${this.editorInstanceId}] Unregistered from global registry`);
            console.log(`[Global Publication] Remaining modals:`, window._publicationModalRegistry.size);
        }

        // Remove modal-level focus blocker/style
        try {
            if (this.modalFocusBlocker) {
                document.removeEventListener('focusin', this.modalFocusBlocker, true);
                this.modalFocusBlocker = null;
            }
            const s = document.getElementById('wi-modal-tabs-block');
            if (s) s.remove();
        } catch (e) {}

        // Restore inert/aria-hidden on tabs subtree
        try {
            if (this._tabsRootEl) {
                this._tabsRootEl.removeAttribute('inert');
                this._tabsRootEl.removeAttribute('aria-hidden');
                this._tabsRootEl = null;
            }
        } catch (e) {}
    }

    restoreTabIndexes = () => {
        // Re-enable tab focusing when modal closes
        const tabHeaders = document.querySelectorAll('.react-tabs__tab');
        tabHeaders.forEach(tab => {
            const originalTabIndex = tab.getAttribute('data-original-tabindex-pub');
            if (originalTabIndex !== null) {
                tab.setAttribute('tabindex', originalTabIndex);
                tab.removeAttribute('data-original-tabindex-pub');
                console.log(`[Publication Modal ${this.editorInstanceId}] Restored tabindex for tab:`, tab.id);
            }
        });
    }

    handleFileChange(event) {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setPreviewImage(reader.result, file.name)
                this.setState({ selectedImage: reader.result });
            };
            reader.readAsDataURL(file);
            this.setState({ uploadedImage: true, isImageSaved: false });
        }
    }

    accessFileInput = () => {
        let fileInput = document.getElementById('choose-file');
        if (!fileInput.files.length) {
            return window.alert("No file selected for upload.");
        }
        return fileInput.files[0];
    }

    isCorrectFileExtension = (path, viewWindow) => {
        if (path.indexOf(' ') >= 0) {
            viewWindow.classList.remove("wait")
            return window.alert("We do not currently support file names with spaces.")
        }
        let regex = new RegExp(/.(png|PNG|tiff|TIFF|jpg|JPG|jpeg|JPEG|mp4|MP4|MOV|mov|mp3|MP3|pdf|PDF)$/)
        let match = path.match(regex)
        let fileExtension = match ? match[0].slice(1) : null
        if (fileExtension && fileExtension.includes(".")){
            return fileExtension.slice(1)
        }
        return fileExtension
    }

    uploadMediaFile = () => {
        let viewWindow = document.getElementById('wi-author-page')
        viewWindow.classList.add("wait");
        const attachment = this.accessFileInput()
        const path = attachment.name
        const fileExtension = this.isCorrectFileExtension(path, viewWindow)
        if(fileExtension){
            const fd = new FormData();
            fd.append('attachment', attachment)
            fd.append('path', path)
            this.saveImageToDB(fd, fileExtension, viewWindow)
        }else {
            viewWindow.classList.remove("wait")
            return window.alert("You are attempting to upload an attachment type that is not supported. Supported attachment extensions are .png, .tiff, .jpg, .jpeg, .mp4, .mov, .mp3, and .pdf. If you are attempting to upload a model, please use the Model Uploader.")
        }
    }

    setViewWindowTimeOut = (viewWindow) => {
        setTimeout(() => {
            viewWindow.classList.remove("wait");
        }, 5000);
    }

    updateImageOptionsState = (payLoad) => {
        let images = []
        let imageOptions = cloneDeep(this.state.imageOptions)
        let updatedImages = imageOptions.concat(images, fileKey(payLoad))
        this.setState({imageOptions: updatedImages})
    }

    setWIAndImageStates = (payLoad) => {
        // The uploaded image is an attachment now, so point at it by its key.
        const imageName = fileKey(payLoad);
        this.setState({ imageName });
        let workInstruction = cloneDeep(this.props.workInstruction);
        workInstruction.previewImages.push(payLoad);
        workInstruction.preview_img = imageName;
        this.updateImageOptionsState(payLoad);
        this.props.setPreviewImage(imageName);
        this.props.setPreviewImages(workInstruction.previewImages);
        this.props.updateWorkInstruction(workInstruction);
    }

    saveImageToDB = (fd, fileExtension, viewWindow) => {
        this.setViewWindowTimeOut(viewWindow);


                Promise.all([this.props.uploadFile(fd)]).then(([res]) => {
                    let payload = { _id: res._id, fileExtension, path: res.path, is_preview_image: 1 }
                    payload.WIPID = this.props.WIPID
                    payload.HighlightID = null
                    payload.StepID = null
                    payload.order = 1

                    createAttachmentInUse(payload).then((data)=>{
                        this.setState({ isImageSaved: true, uploadedImage: false})
                        this.setWIAndImageStates(data.data);
                    }).catch(e=>{
                        window.alert("An Error occured in uploading that file.", e)
                        viewWindow.classList.remove("wait")
                    })


                    }).catch(e=>{
                        window.alert("An Error occured in uploading that file.", e)
                        viewWindow.classList.remove("wait")
                    })  
 
             
  
 
    }

    checkKey = (e, state) => {
        if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
            let collections = { "reference": true, "figure": true, "table": true, "enclosure": true }
            let isCollection = (collections[state])

            if (isCollection) {
                let currentCollection = `${state}s`
                let nextState = this.state[currentCollection]
                let nextCollection = [...nextState, this.state[state]]
                this.setState({
                    [state]: "",
                    [`${state}s`]: nextCollection
                })
            }

            this.setState({
                [state]: this.state[state],
            })
        }
    }

    setStepAttachments = () => {
        let attachmentImages = []
        this.props.steps.forEach(step => {
            let attachments = step.attachments || []
            attachments.forEach(attachment => {
                if (isImage(attachment.fileExtension)) {
                    attachmentImages.push(fileKey(attachment))
                }
            })
        })
        return attachmentImages
    }

    setPreviewAttachments = () => {
        let attachmentImages = []
        this.props.workInstruction.previewImages.forEach(attachment => { 
           console.dir(attachment["Attachment.file_extension"])
            if (isImage(attachment["Attachment.file_extension"])) {
                const previewPath = attachment["Attachment.path"] || attachment.path
                // Raw rows have the attachment's ID in "Attachment._id"; their own _id is the in-use record's.
                const previewId = attachment["Attachment._id"] || attachment._id
                if (previewPath && previewId) {
                    attachmentImages.push(fileKey({ _id: previewId, path: previewPath }))
                }
            }
        })
        return attachmentImages
    }

    generatePreviewImageOptions = () => {
        let imageOptions = []
        const stepImages = this.setStepAttachments()
        const previewImages = this.setPreviewAttachments()
        const combinedImages = imageOptions.concat(stepImages, previewImages)
        return combinedImages
    }

    updateField(field) {
        return e => this.setState({
            
            [field]: e.currentTarget.value
        },()=>alert(e.currentTarget.value));
    }

    updateItem = (collection, stateName, oldItem, updatedItem) => {
        collection = collection.map(iterItem => {
            if (iterItem === oldItem) {
                return updatedItem
            } else {
                return iterItem
            }
        })
        let editingItem = this.state.editingItem
        editingItem[stateName] = false
        this.setState({
            editingItem,
            [stateName]: collection
        })
    }

    cancelEdit = (stateName) => {
        this.setState(prevState => {
            let nextState = prevState.editingItem
            nextState[stateName] = ""
            return { editingItem: nextState }
        });
    }

    deleteItem = (collection, stateName, item) => {
        collection = collection.filter(iterItem => iterItem !== item)
        this.setState({
            [stateName]: collection
        })
    }

    renderCollection = (collection, stateName) => {
        return collection.map((item) => {
            return this.state.editingItem[stateName] === item ?
                <EditItemFieldContainer key={`editing item - ${this.props.item}`} item={this.state.editingItem[stateName]}
                    cancel={() => this.cancelEdit(stateName)}
                    submitItemChange={(updatedItem) => this.updateItem(collection, stateName, item, updatedItem)}
                />
                :
                <li style={{marginTop:'6px'}} key={`${stateName} - ${item}`} className="clickable flex-apart" onClick={(e) => this.editItem(stateName, item)}>
                    <p>{item}</p>
                    {trashIcon(() => this.deleteItem(collection, stateName, item), true)}
                </li>
        })
    }

    setPreviewImage = (path, imageName) => {
        this.setState({
            showingPreviewOptions: false,
            previewImage: path,
            imageName: imageName
        })
        this.props.setPreviewImage(imageName)
    }

    editItem = (stateName, item) => {
        this.setState({
            editingItem: { [stateName]: item }
        })
    }

    setInfoChecksRequirement = () => {
        this.props.infoChecksRequirement ?
            this.props.setInfoChecksRequirement(false)
            :
            this.props.setInfoChecksRequirement(true)
    }

    parseDateArray = (MSSQLDate) => {
        return [moment(MSSQLDate, 'YYYY-MM-DD').format('dddd, MMMM Do, YYYY')];
    }

    parseDate = (MSSQLDate) => {
        let creationTimestampMs = Number(MSSQLDate);
        let formattedDate = moment(creationTimestampMs).format('dddd, MMMM Do, YYYY');
        return formattedDate;
    }

    setEditedWITitle = (title) => {
        let hasSC = hasSpecialChar(title)
        if(hasSC){
            window.alert("Title cannot contain special characters: &, ~, |, \\, /, *, ?, :, #")
            return false
        }
        this.setState({
            editedWITitle: title
        },()=> this.props.setTitle(title))
       
        return true
    }

    setPublicationPage = () => {
        let page= {docNum: this.state.docNum, 
            identificationAndClassification: this.state.identificationAndClassification, 
            system: this.state.system, 
            subSystem: this.state.subSystem, 
            subject: this.state.subject, 
            references: this.state.references, 
            figures: this.state.figures, 
            enclosures: this.state.enclosures}
        this.props.updatePublicationPage(page)
    }

    updatePayload = () => {
        let rescissionDate = document.getElementById('select-category').value
        let payload = {
            WITitle: this.state.editedWITitle,
            docNum: this.state.docNum,
            createdBy: this.props.workInstruction.publication_page.createdBy,
            identificationAndClassification: this.state.identificationAndClassification,
            rescissionDate: rescissionDate,
            system: this.state.system,
            subSystem: this.state.subSystem,
            subject: this.state.subject,
            references: this.state.references,
            figures: this.state.figures,
            enclosures: this.state.enclosures,
        }
        return payload
    }

    releaseWorkInstruction = async (closeModal) => {
        const pubPayload = this.updatePayload(); // Gets local form data

        let result = window.confirm("You are about to release your work instruction. Any unsaved changes will be automatically saved. Press 'OK' to continue.")
        if (result) {
            // Construct the comprehensive data object for saveWorkInstruction
            const publicationDataForSave = {
                publicationPagePayload: pubPayload,
                title: this.state.editedWITitle, // Current title from PublicationPage state
                previewImageName: this.state.imageName, // Current selected image name from PublicationPage state
                infoChecksRequirement: this.props.infoChecksRequirement // Current value from WIAuthorSteps via props
            };

            // Call the save function passed from the parent, instructing it to release
            // Pass publicationDataForSave object and the closeModal function as a callback
            this.props.saveWorkInstruction(
                true, // togglingRelease = true
                true, // nextReleaseState = true (releasing)
                publicationDataForSave, // The comprehensive publication data
                this.props.closeModal // The callback function to close the modal after save completes
            );
        }
    }

    generateDateOptions = (span) => {
        console.log("this.props.workInstruction.creation_date:"+this.props.workInstruction.creation_date)
        let creationTimestampMs = Number(this.props.workInstruction.creation_date);
        let date = moment(creationTimestampMs).toDate(); // Parse the timestamp
        date.setFullYear(date.getFullYear() + span); // Add the span to the year

        let futureMoment = moment(date);
        let formattedDate = futureMoment.format('dddd, MMMM Do, YYYY'); // Format the date for display
        let futureTimestampMs = futureMoment.valueOf(); // Get Unix timestamp in milliseconds

        console.log("formattedDate:"+formattedDate);
        console.log("futureTimestampMs:"+futureTimestampMs);

        // Note: The 'selected' logic still compares with the formattedDate string based on the previous code.
        // If rescissionDate is stored as a timestamp, this comparison should be adjusted.
        const isSelected = this.props.publicationPage?.rescissionDate
            ? this.props.publicationPage.rescissionDate === formattedDate // Keep existing string comparison for now
            : span === 1; // Default to 1 year span if no rescissionDate is set

        return (
            <option
                key={futureTimestampMs} // Use timestamp for key as well
                selected={isSelected}
               
                value={futureTimestampMs} // Use timestamp for the value
            >
                {formattedDate} {/* Display the formatted date */}
            </option>
        );
    }

    render = () => 
    (
        <div id="publication-page">
            <style>{`
                /* Isolate modal paints and disable animated focus styles to prevent flicker */
                #publication-page, #publication-page-inside {
                    backface-visibility: hidden;
                }
                #publication-page input,
                #publication-page input:focus {
                    outline: none;
                    box-shadow: none;
                    transition: none;
                    border-width: 1px;
                }
                #publication-page .form-input,
                #publication-page tr,
                #publication-page td {
                    transition: none;
                }
            `}</style>
            <div id="publication-page-inside" className="flex-column" style={{justifyContent: "flex-start"}}>
                {/* ------------------------- TOP DETAIL MENU -------------------------- */}
                <div id="columns-container" className="flex overflow" style={{marginRight:'1%', marginTop:'-10px'}}>
                    <Fragment>
                        {/* <div style={{display: "flex", flexDirection: "row", marginLeft: '5%'}}>
                            <input type="text" placeholder="Search" style={{width: '200px', height: '30px', borderRadius: '5px', border: '1px solid #52628F'}}/>
                        </div> */}
                        <FormColumn title={"Work Instruction Title"} columnWidth={"17%"} content={[this.state.editedWITitle]} setEditedWITitle={this.setEditedWITitle} numColumns={4} nullSort={true}/>

                        {(()=>{
                            const pubPage = this.props.publicationPage || {};
                            const createdByVal = pubPage.createdBy || "";
                            return <FormColumn title={"Created By"} columnWidth={"13%"} content={[createdByVal]} numColumns={4} nullSort={true}/>;
                        })()}
                        <FormColumn title={"Created On"} columnWidth={"35%"} content={[this.parseDate(this.props.workInstruction.creation_date)]} numColumns={4} nullSort={true} />
                        <FormColumn title={"Last Modified"} columnWidth={"35%"} content={[this.parseDate(this.props.workInstruction.modified_date)]} numColumns={4} nullSort={true}/>

                    </Fragment>
                </div>


                {/* ---------------------------------- IMAGE CAROUSEL  ----------------------------------*/}
                <div id="image-carousel" style={{border: "1px solid #52628F", display: "flex", flexDirection: "row", alignItems: "center", height:'235px', marginTop:'20px', marginRight: '1%'}}>
                    <div id="preview-text" style={{marginLeft: '5%', width: '150px', whiteSpace: 'nowrap'}}>Preview Image:</div>
                    {this.state.previewImage ? (
                        <div id="file-upload" style={{display: "flex", flexDirection: "column", alignItems: "center", marginLeft: '5%'}}>
                            <img src={this.state.previewImage} alt="Selected" style={{ marginTop:'8%', width: '240px', height: 'auto', maxHeight: '170px', border:'1px solid #8AA9FF'}} />
                            <input type="file" id="choose-file" accept="image/*" style={{display: "none"}} onChange={this.handleFileChange} />
                            <div style={{display: "flex", flexDirection: "row", marginTop:'2%'}}>
                                <button 
                                    className="custom-button"
                                    style={{width:'100px'}}
                                    onClick={() => document.getElementById('choose-file').click()}
                                >
                                    Choose File
                                </button>  
                                {this.state.uploadedImage && 
                                    <button
                                        className="custom-button"
                                        style={{marginLeft:'5%'}}
                                        onClick={this.uploadMediaFile}
                                    >
                                        Save
                                    </button>
                                }
                            </div>
                        </div>
                    ) : (
                        <div id="file-upload" style={{display: "flex", flexDirection: "column", alignItems: "center", marginLeft: '5%'}}>
                            <button className="highlight-on-hover" onClick={() => document.getElementById('choose-file').click()}>
                                <img src={PlusIcon} alt="plus" />
                            </button>
                            <input type="file" id="choose-file" accept="image/*" style={{display: "none"}} onChange={this.handleFileChange} />
                            <div style={{display: "flex", flexDirection: "row", marginTop:'27%'}}>
                                <button 
                                    className="custom-button"
                                    style={{width:'100px'}}
                                    onClick={() => document.getElementById('choose-file').click()}
                                >
                                    Choose File
                                </button>  
                            </div>
                        </div>
                    )}                 
                    <div id="preview-text" style={{marginLeft: '5%', width:'10%', textAlign: 'center'}}>Or Pick From Attachment List</div>
                    {this.state.imageOptions && this.state.imageOptions.length > 0 ? (
                        <div id="carousel" style={{overflowX: "auto", whiteSpace: "nowrap", marginLeft: '5%', marginRight:'10px'}}>
                            {this.state.imageOptions.map((path, index) => (
                                <img 
                                    key={index} 
                                    src={fileUrl(path)}
                                    alt="work instruction preview"
                                    style={{width: 'auto', height: '195px', marginLeft:'10px', border: this.state.lastClickedImage === index ? '2px solid blue' : 'none'}} 
                                    onClick={(e) => {
                                        if (this.state.lastClickedImage === index) {
                                            this.setState({lastClickedImage: null, uploadedImage: false, uniqueImageName: true, isImageSaved: true}, () => this.setPreviewImage(null));
                                        } else {
                                            this.setState({lastClickedImage: index, uploadedImage: false, uniqueImageName: true, isImageSaved: true}, () => this.setPreviewImage(fileUrl(path), path));
                                        }
                                    }} 
                                />
                            ))}
                        </div>
                    ) : (
                        <div style={{textAlign: 'center', color: 'red', fontWeight: 'bold', marginRight:'5%', width:'50%'}}>
                            No Image Options Available
                        </div>
                    )}
                </div>


                <div className="form-grid" style={{marginRight:'0.6%', marginTop:'2%', overflow: 'visible'}}>
                    <table style={{width: '99.7%'}}>
                        {/* ------------------------------------------------- Row 1 ------------------------------------------------- */}
                        <tbody>
                            <tr style={{backgroundColor: invertColor}}>
                                <td className="label-column" style={{marginLeft:'5%'}}>
                                    <label htmlFor="docNum" className="invert-form-label">Document Number:</label>
                                </td>
                                <td>
                                    <input id="docNum" className="invert-form-input"
                                        type="text"
                                        value={this.state.docNum}
                                        onChange={(e)=>this.setState({docNum: e.currentTarget.value})}
                                        placeholder="Add Document Number here"
                                    />
                                </td>
                            </tr>
                        
                            {/* ------------------------------------------------- Row 2 ------------------------------------------------- */}
                            
                            <tr>
                                <td>
                                    <label htmlFor="identification/classification" className="form-label">Identification / Classification:</label>
                                </td>
                                <td>
                                    <input id="identification/classification" className="form-input"
                                        type="text"
                                        value={this.state.identificationAndClassification}
                                        onChange={(e)=>this.setState({identificationAndClassification: e.currentTarget.value})}
                                        placeholder="Add Identification/Classification info here"
                                    />
                                </td>
                            </tr>
                            {/* ------------------------------------------------- Row 3 ------------------------------------------------- */}
                            <tr style={{backgroundColor: invertColor}}>
                                <td style={{marginLeft:'5%'}}>
                                    <label htmlFor="system" className="invert-form-label">System:</label>
                                </td>
                                <td>
                                    <input id="system" className="invert-form-input"
                                    type="text"
                                    value={this.state.system}
                                    onChange={(e)=>this.setState({system: e.currentTarget.value})}
                                    placeholder="Add System info here"
                                    />
                                </td>
                            </tr>
                            {/* ------------------------------------------------- Row 4 ------------------------------------------------- */}
                            <tr>
                                <td>
                                    <label htmlFor="subSystem" className="form-label">Sub System:</label>
                                </td>
                                <td>
                                    <input id="subSystem" className="form-input"
                                    type="text"
                                    value={this.state.subSystem}
                                    onChange={(e)=>this.setState({subSystem: e.currentTarget.value})}
                                    placeholder="Add Sub System info here"
                                    />
                                </td>
                            </tr>
                            {/* ------------------------------------------------- Row 5 ------------------------------------------------- */}
                            <tr style={{backgroundColor: invertColor}}>
                                <td>
                                    <label htmlFor="subject" className="invert-form-label">Subject:</label>
                                </td>
                                <td>
                                    <input id="subject" className="invert-form-input"
                                    type="text"
                                    value={this.state.subject}
                                    onChange={(e)=>this.setState({subject: e.currentTarget.value})}
                                    placeholder="Add Subject info here"
                                    />
                                </td>
                            </tr>
                            {/* ------------------------------------------------- Row 6 ------------------------------------------------- */}
                            <tr >
                                <td>
                                    <label htmlFor="references" className="form-label">References:</label>
                                </td>
                                <td>
                                    <div className="form-input">
                                        {this.state.references ? <ol>
                                            {this.renderCollection(this.state.references, "references")}
                                        </ol> : null}
                                        <input id="reference" className='special-form-input'
                                            type="text"
                                            value={this.state.reference}
                                            onChange={(e)=>this.setState({reference: e.currentTarget.value})}
                                            placeholder="Add to list of References here"
                                        />
                                    </div>
                                </td>
                            </tr>
                            {/* ------------------------------------------------- Row 7 ------------------------------------------------- */}
                            <tr style={{backgroundColor: invertColor}}>
                                <td>
                                    <label htmlFor="figures" className="invert-form-label">Figures:</label>
                                </td>
                                <td>
                                    <div className="form-input">
                                        {this.state.figures ? <ol>
                                            {this.renderCollection(this.state.figures, "figures")}
                                        </ol> : null}
                                        <input id="figure" className='invert-special-form-input'
                                            type="text"
                                            value={this.state.figure}
                                            onChange={(e)=>this.setState({figure: e.currentTarget.value})}
                                            placeholder="Add to list of figures here"
                                        />
                                    </div>
                                </td>
                            </tr>
                            {/* ------------------------------------------------- Row 8 ------------------------------------------------- */}
                            <tr>
                                <td>
                                    <label htmlFor="enclosures" className="form-label">Enclosures:</label>
                                </td>
                                <td>
                                    <div className="form-input">
                                        {this.state.enclosures ? <ol>
                                            {this.renderCollection(this.state.enclosures, "enclosures")}
                                        </ol> : null}
                                        <input id="enclosure" className='special-form-input'
                                            type="text"
                                            value={this.state.enclosure}
                                            onChange={(e)=>this.setState({enclosure: e.currentTarget.value})}
                                            placeholder="Add An Enclosure"
                                        />
                                    </div>
                                </td>
                            </tr>
                            {/* ------------------------------------------------- Row 9 ------------------------------------------------- */}
                            <tr style={{backgroundColor: invertColor}}>
                                <td>
                                    <label htmlFor="enclosures" className="invert-form-label">Rescission Date:</label>
                                </td>
                                <td>
                                    <div className="form-input">
                                        <select name="Rescission Date" id="select-category" value={this.state.rescissionDate} className="dropdown-dates" style={{width: '67%'}}>
                                            {this.state.generateDateOptionsArray[0]}
                                            {this.state.generateDateOptionsArray[1]}
                                            {this.state.generateDateOptionsArray[2]} 
                                
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            {/* ------------------------------------------------- Row 10 ------------------------------------------------- */}
                            {/* <tr>
                                <td>
                                    <label htmlFor="enclosures" className="form-label">Require Alert Page Checks</label>            
                                </td>
                                <td>
                                    <div className="form-input">
                                        <input id="identification/classification" className="publication-input-field"
                                            type="checkbox"
                                            style={{ marginRight:"auto", width:"30px", height:"30px"}}
                                            checked={this.props.infoChecksRequirement}
                                            onChange={()=>this.setInfoChecksRequirement()}
                                        />
                                    </div>
                                </td>
                            </tr>  */}
                        </tbody>              
                    </table>
                </div>
                <div className="button-container" style={{backgroundColor: 'white', paddingTop: '0.6%'}}>
                    {this.state.isImageSaved ? (
                        <div className="max-width flex-centered" style={{position: 'sticky', bottom: 0, height:"7%", paddingBottom: '0.3%'}}>
                            <button onClick={() => this.releaseWorkInstruction(this.props.closeModal)} id="confirmation-button">Release Work Instruction</button>
                        </div>
                    ) : (
                        <div className="max-width flex-centered" style={{position: 'sticky', bottom: 0, height:"7%", paddingBottom: '0.3%'}}>
                            <button id="confirmation-button-grayed">Release Work Instruction</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}